export const Lineprogress = () => (
  <svg width="203" height="8" viewBox="0 0 203 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="203" height="8" rx="4" fill="#EAECF0" />
    <rect width="203" height="8" rx="4" fill="#007EFF" />
  </svg>
);
